import { render, staticRenderFns } from "./A03.vue?vue&type=template&id=72b9ace6&scoped=true"
import script from "./A03.vue?vue&type=script&lang=js"
export * from "./A03.vue?vue&type=script&lang=js"
import style0 from "./A03.vue?vue&type=style&index=0&id=72b9ace6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b9ace6",
  null
  
)

export default component.exports